module.exports = __webpack_public_path__ + "img/logo.1008a8de.svg";